<ng-template *ngIf="cs.isBrowser">
<div class="modal-basic modal-center-aligned">
  <div class="modal-body modal-metatask">
    <h5>Follow These Steps to Unlock via NFT:</h5>
    <p>1. Use a Chrome Desktop Computer Browser</p>
    <p>
      2. Download and Install the MetaMask Chrome Plugin
      <a href="https://metamask.io" target="_blank">https://metamask.io</a>
    </p>
    <p>
      3. Login into your Wallet and choose the chain that your NFT is in (e.g.
      Polygon)
    </p>
    <p>4. Go to Edit Preferences > Connect my NFT Wallet</p>
  </div>
  <div class="modal-footer modal-footer-center">
    <button (click)="closeDialog()" class="btn btn-primary mx-2" type="button">
      OK
    </button>
  </div>
</div>
</ng-template>